import * as Yup from 'yup';

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export const getUrlSchema = (error: string) =>
  Yup.string()
    .transform(currentValue => {
      const doesNotStartWithHttp =
        typeof currentValue === 'string' &&
        currentValue.trim() &&
        !(
          currentValue.startsWith('http://') ||
          currentValue.startsWith('https://')
        );

      if (doesNotStartWithHttp) {
        return `https://${currentValue}`;
      }

      return currentValue;
    })
    .url(error);

declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void };
  }
}
